import mapboxgl from 'mapbox-gl'
import { onMounted } from '@vue/composition-api'

export default useMapboxPopup
/**
 * @typedef {Function} HtmlBuilder
 * function to build a popup from properties
 * @param  {Array.<string>} properties  a set of layer properties
 * @returns {String} html string
 */
function defaultHtml(properties) {
  return Object.entries(properties)
    .filter(([key, value]) => !['fid', 'adidu', 'h3_id'].includes(key))
    .map(([key, value]) => `<b>${key}: </b>${value}`)
    .join('<br>')
}
/**
 * set a popup config to be display on feature click
 * @param  {Object} mapRef a gl-map component vue ref
 * @param  {String} layer a  layer id
 * @param  {HtmlBuilder} htmlBuilder the function to build html from layer properties list
 * @alias module:map-composable
 */
function useMapboxPopup(mapRef, layer, htmlBuilder = defaultHtml) {
  onMounted(async () => {
    const map = mapRef.value.map
    map.on('click', layer, e => {
      const properties = e.features[0].properties
      new mapboxgl.Popup()
        .setLngLat(e.lngLat)
        .setHTML(htmlBuilder(properties))
        .addTo(map)
    })
    map.on('mouseenter', layer, () => {
      map.getCanvas().style.cursor = 'pointer'
    })

    map.on('mouseleave', layer, () => {
      map.getCanvas().style.cursor = ''
    })
  })
}
